function enumize(enumDefinition) {
  const byId = {};
  const list = [];
  let key;
  let temp;

  for (key in enumDefinition) {
    if (enumDefinition.hasOwnProperty(key)) {
      temp = Object.assign({}, enumDefinition[key]);
      delete temp.id;
      temp[key] = key;
      list.push({
        label: enumDefinition[key].label,
        value: enumDefinition[key].id,
      });
      byId[enumDefinition[key].id] = temp;
    }
  }
  enumDefinition.ids = byId;
  enumDefinition.list = list;
  return enumDefinition;
}

export const BLOCKS_POSITIONS = enumize({
  RIGHT_SIDEBAR: 2,
  FOOTER: 4,
});

export const BLOCKS_PREDEFINED = enumize({
  BLOCK_USEFUL_LINK: 1,
  //BLOCK_POLL: 2, // 11.11.2024 - Polls is not used anymore and is removed. For polls are used page not block.
  BLOCK_CALENDAR: 3,
  BLOCK_WEATHER: 5,
});

export const FIJ_JOB_STATUS = enumize({
  WAITING: 'Čaká na schválenie',
  APPROVED: 'Schválená',
  REJECTED: 'Zamietnutá',
  DEFENDED: 'Obhájená',
  UNDEFENDED: 'Neobhájená',
  ARCHIVED: 'Archivovaná',
});

// Centralized Tag colors for FRI internal job statuses (Ant Design preset colors)
export const FIJ_JOB_STATUS_COLORS = {
  [FIJ_JOB_STATUS.WAITING]: 'orange',
  [FIJ_JOB_STATUS.APPROVED]: 'green',
  [FIJ_JOB_STATUS.REJECTED]: 'purple',
  [FIJ_JOB_STATUS.DEFENDED]: 'blue',
  [FIJ_JOB_STATUS.UNDEFENDED]: 'red',
  [FIJ_JOB_STATUS.ARCHIVED]: 'geekblue',
};

// Dedicated alias for jobs
export function statusColorJob(status) {
  return FIJ_JOB_STATUS_COLORS[status] || 'default';
}

export const FIJ_INTEREST_STATUS = enumize({
  WAITING: 'Čaká na vyjadrenie',
  ACCEPTED: 'Prijatý na FRI prax',
  ACCEPTED_ON_ANOTHER_FIJ: 'Prijatý na inú FRI prax',
  NOT_ACCEPTED: 'Neprijatý na FRI prax',
  NOT_FINISHED: 'Neúspešne ukončil FRI prax',
  SUCCESSFULLY_FINISHED: 'Úspešne ukončil FRI prax',
});

// Centralized Tag colors for FRI interest statuses
export const FIJ_INTEREST_STATUS_COLORS = {
  [FIJ_INTEREST_STATUS.WAITING]: 'orange',
  [FIJ_INTEREST_STATUS.ACCEPTED]: 'green',
  [FIJ_INTEREST_STATUS.ACCEPTED_ON_ANOTHER_FIJ]: 'gold',
  [FIJ_INTEREST_STATUS.NOT_ACCEPTED]: 'purple',
  [FIJ_INTEREST_STATUS.NOT_FINISHED]: 'volcano',
  [FIJ_INTEREST_STATUS.SUCCESSFULLY_FINISHED]: 'blue',
};

export function statusColorInterest(status) {
  return FIJ_INTEREST_STATUS_COLORS[status] || 'default';
}

export const FJ_STATUS = enumize({
  WAITING: 'Čaká na schválenie',
  APPROVED: 'Schválená',
  REJECTED: 'Neschválená',
  ARCHIVED: 'Archivovaná',
});

export const FIJ_INTEREST_REJECT_REASONS = [
  { key: '1', label: 'z kapacitných dôvodov' },
  { key: '2', label: 'nespĺňa požiadavky na prax' },
  { key: '3', label: 'odmietnutie zo strany lektora' },
];

export const FRI_EDU_DATE_STATUS = enumize({
  WAITING: { STATE: 'waiting', LABEL: 'Pripravuje sa', COLOR: 'gold' },
  ONGOING: { STATE: 'ongoing', LABEL: 'Prebieha', COLOR: 'cyan' },
  CANCELLED: { STATE: 'cancelled', LABEL: 'Zrušený', COLOR: 'red' },
  FULLY_BOOKED: {
    STATE: 'fully_booked',
    LABEL: 'Plne obsadený',
    COLOR: 'orange',
  },
  REGISTRATION_OPEN: {
    STATE: 'registration_open',
    LABEL: 'Registrácia otvorená',
    COLOR: 'green',
  },
  REGISTRATION_CLOSED: {
    STATE: 'registration_closed',
    LABEL: 'Registrácia uzavretá',
    COLOR: 'volcano',
  },
  COMPLETED: { STATE: 'completed', LABEL: 'Ukončený', COLOR: 'purple' },
});

export const RESERVATION_STATUS = enumize({
  ACCEPTED: { STATE: 'accepted', LABEL: 'Schválená', COLOR: 'green' },
  WAITING: { STATE: 'waiting', LABEL: 'Čaká na schválenie', COLOR: 'orange' },
  REJECTED: { STATE: 'rejected', LABEL: 'Neschválená', COLOR: 'red' },
});

export const PAGE = enumize({
  EMAIL: 'web@fri.uniza.sk',
  VERSION: '3.0',
});

export const MENU_ITEM_TYPES = enumize({
  ARTICLE: { id: 'article', label: 'Článok' },
  EXTERNAL: { id: 'external', label: 'Externý odkaz' },
  INTERNAL: { id: 'internal', label: 'V rámci portálu' },
  SUBMENU: { id: 'submenu', label: 'Podmenu' },
});

export const YELLOW_BOOKS_SECTION_TYPES = enumize({
  TEXT: { id: 'text', label: 'Text' },
  HEADING: { id: 'heading', label: 'Nadpis' },
  DATA: { id: 'data', label: 'Dáta' },
});

export const TEXT_ALIGN = enumize({
  LEFT: { id: 'left', label: 'Vľavo' },
  CENTER: { id: 'center', label: 'Stred' },
  RIGHT: { id: 'right', label: 'Vpravo' },
});

export const HEADING_PREFIX = enumize({
  DECIMAL: { id: '1', label: '1' },
  LETTER: { id: 'A', label: 'A' },
  LOWER_LETTER: { id: 'a', label: 'a' },
  // ROMAN: { id: 'I', label: 'I' },
  // LOWER_ROMAN: { id: 'i', label: 'i' },
});

export const OVERVIEW_FILTER_ROOM_TYPES = enumize({
  ALL: 'Všetky',
  RA: 'RA',
  RB: 'RB',
  RC: 'RC',
  DEPARTMENT_ROOM: 'Katedrové',
  OTHER: 'Ostatné',
});

export function isRightSidebar(value) {
  return value === BLOCKS_POSITIONS.RIGHT_SIDEBAR;
}

export function isFooterBlock(value) {
  return value === BLOCKS_POSITIONS.FOOTER;
}

export const SHOW_MOBILE_NAV_WIDTH = 992;
